import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import wrapper from "./Wrapper";

export default (history) =>
  combineReducers({
    wrapper,
    router: connectRouter(history),
  });
